import React from "react";
import { FaSave } from "react-icons/fa";
import { FaTimes, FaCheck } from "react-icons/fa";  // Import FontAwesome close (X) and save icons

interface FormActionButtonsProps {
  edit: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;  // Expecting a form event
  disabled?: boolean;  // Optional disabled prop to manage button state
}

const FormActionButtons: React.FC<FormActionButtonsProps> = ({ edit, onClose, onSubmit, disabled = false }) => {
  return (
    <div className="flex justify-end space-x-4 mt-6">
      <button
        type="button"
        onClick={onClose}
        className="flex items-center justify-center bg-red-600 text-white hover:bg-red-700 rounded-full w-12 h-12 text-2xl"
      >
        <FaTimes />  
      </button>
    
      {edit ? (
        <button
          type="submit"
          onClick={onSubmit}
          disabled={disabled}
          className={`bg-brand-500 text-white px-6 py-3 rounded-md hover:bg-brand-600 transition-colors flex items-center space-x-2 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaSave className="text-2xl" />
        </button>
      ) : (
        <button
          type="submit"
          onClick={onSubmit}
          disabled={disabled}
          className={`bg-brand-500 text-white px-6 py-3 rounded-md hover:bg-brand-600 transition-colors flex items-center space-x-2 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaCheck className="text-2xl" />
        </button>
      )}
    </div>
  );
};

export default FormActionButtons;
